import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	descriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.notifications-step.card-one.description-non-final',
		defaultMessage: `Get notified of alerts, check on-call schedules, and manage your notifications on the go, with the Jira Cloud mobile app.

{hideMiddleParagraph, select,
    true {}
    other {{isRBNEnabled, select,
        true {A central notification template applies to you, so you need the Jira Cloud mobile app to receive push notifications for alerts and on-call. Central notification templates are called role-based notifications in Jira Service Management.}
        other {Once you’ve installed it, you can add it as a notification method to start receiving push notifications for alerts and on-call. Your notification rules from Opsgenie will be copied to your Jira Cloud mobile app, without any changes.}
    }}
}

Make sure your Jira Cloud mobile app is up-to-date and that you allow it to send you push notifications in your mobile settings.`,
		description:
			'Description of the Jira cloud app step cards inside notifications onboarding step in markdown format.',
	},
	couldntDetectJnaNonFinal: {
		id: 'eoc-changeboarding.transition-home.notifications-step.card-one.couldnt-detect-jna-non-final',
		defaultMessage: 'Couldn’t detect any mobile device with Jira Cloud app installed',
		description: 'Text to show when the Jira cloud app is not detected.',
	},
	addedJnaNonFinal: {
		id: 'eoc-changeboarding.transition-home.notifications-step.card-one.added-jna-non-final',
		defaultMessage: 'Added. You’ll now get push notifications from the Jira Cloud mobile app.',
		description: 'Text to show when the Jira cloud app is detected.',
	},
	downloadJna: {
		id: 'eoc-changeboarding.transition-home.notifications-step.card-one.download-jna',
		defaultMessage: 'Scan to download the Jira Cloud mobile app',
		description: 'Text displayed under the QR code to download the Jira cloud app.',
	},
});
